import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@finitless/shared/lib";

/**
 * Hook to fetch cities from countries
 */
export const useCities = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["cities"],
    queryFn: async () => {
      const response = await apiClient.get("/countries");

      if (response.error) {
        throw new Error("Failed to fetch countries");
      }

      let cities = [];
      if (response.result && Array.isArray(response.result)) {
        for (const country of response.result) {
          if (country?.enabled && country?.cities) {
            cities = [...cities, ...country.cities];
          }
        }
      }

      return cities;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
  });

  return {
    cities: data || [],
    isLoading,
    error,
    firstCityId: data && data.length > 0 ? data[0]?.id : null,
  };
};

export default useCities;
